import React, { useState, useEffect, useRef } from "react";
import "./WorksSlider.css";
import PageIndicators from "./PageIndicator/PageIndicator";



const works = [
  {
    id: 1,
    title: "Meek XRP",
    description:
      "Meek XRP is a trusted digital exchange brand that deals in gift cards, cryptocurrencies, and fast payment channels like Zelle, Cash App, PayPal, and E-transfer. I design all the brand's graphics, creating clean, engaging visuals that capture users' attention and enhance their overall experience with the brand.",
    background: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091835/meek-xrp-collage_snbhpv.png",
    logo: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091834/MeekXRP_gnlfmy.png",
    borderColor: "#FE0000",
    link: "https://drive.google.com/drive/folders/1ZsAn-hLY2kYV8ammO0gkDg52PvU9cFM1?usp=drive_link"
  },
  {
    id: 2,
    title: "Drip by Meek",
    description:
      "Drip by Meek is a fashion-forward brand focused on premium streetwear visuals. I handled creative direction, social media designs, and campaign graphics that strengthened the brand's identity and online presence.",
    background: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091841/drip-bg_zkuydq.png",
    logo: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091836/drip-logo_npgxya.png",
    borderColor: "#FFFFFF",
    link: "https://drive.google.com/drive/folders/1L1PON4vA8WRvSFaKCOfznmNWLaLmTUhf?usp=drive_link"
  },
  {
    id: 3,
    title: "Tensai Kids",
    description:
      "Tensai Kids is a parenting academy that helps parents raise well-rounded, exceptional children, and also operates the Tensai School of Geniuses (TSOG). I'm the creative graphic designer for the brand, crafting engaging visuals that support their mission and connect with parents and learners.",
    background: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091846/Tensai-Kids-Collage_bj1yox.png",
    logo: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091841/Tensai-Kids_fyheuq.png",
    borderColor: "#FFFFFF",
    link: "https://drive.google.com/drive/folders/1FS5q9zGe7OrQvids0VJHQulDBjijjvfY?usp=drive_link"
  },
  {
    id: 4,
    title: "Edukit",
    description:
      "Edukit Nigeria empowers underprivileged students by providing essential learning materials and bridging the educational resource gap. I was part of the web design team, helping create an engaging, user-friendly digital experience that amplifies their mission and connects students with the tools they need to succeed.",
    background: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091833/Edukit-bg_qjkole.png",
    logo: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091830/Edukit_n0ezpw.png",
    borderColor: "#004AAD",
    link: "https://drive.google.com/drive/folders/1UlgO9E9_S9nSSdXXLAtzfdgKvumCe-LG?usp=drive_link"
  },
  {
    id: 5,
    title: "Many More",
    description:
      "I've also collaborated with a variety of talented individuals and brands, including Victory DM, Toheeb Agency, Passive Income Anna, Chris Obike, and many more, creating visuals and designs that elevate their presence and engage their audiences.",
    background: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091847/Many-More_dozjfn.png",
    logo: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091833/Remzy_ifbjw9.png",
    borderColor: "#EAC94F",
    link: "https://drive.google.com/drive/folders/1ikWBVuvs7bmC5JxFXcMXxtP9AhPLynis?usp=drive_link",
    isLast: true
  }
];

const WorksSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animate, setAnimate] = useState(false);
  const [nextIndex, setNextIndex] = useState(null);
  const transitionRef = useRef(null);

  const activeWork = works[activeIndex];

  useEffect(() => {
    works.forEach(work => {
      const img = new Image();
      img.src = work.background;
    });
  }, []);

  const handleChange = (index) => {
    if (index === activeIndex || nextIndex !== null) return;

    if (transitionRef.current) {
      clearTimeout(transitionRef.current);
    }

    setNextIndex(index);
    setAnimate(true);
    
    transitionRef.current = setTimeout(() => {
      setActiveIndex(index);
      setNextIndex(null);
      setAnimate(false);
    }, 600);
  };

  return (
    <section className={`work-slider ${animate ? "slide" : ""}`}>
      <div
        key={activeWork.id}
        className="bg-layer"
        style={{ backgroundImage: `url(${activeWork.background})` }}
      />

      <div className="fade-overlay" />

      <div className="work-content">
        <div className="work-text">
          <h2>{activeWork.title}</h2>
          <p>{activeWork.description}</p>
          <a
            href={activeWork.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="work-btn">
              {activeWork.isLast ? "View All" : "View More"}
            </button>
          </a>
        </div>

        <div className="work-thumbs">
          <div className="work-thumbs-track">
            {[0, 1].map((offset) => {
              const index = (activeIndex + offset) % works.length;
              const work = works[index];
              
              const isActive = offset === 0;
              const isBecomingActive = index === nextIndex;
              const isBecomingInactive = isActive && nextIndex !== null && nextIndex !== activeIndex;

              let stateClass = "";
              if (isBecomingActive) {
                stateClass = "becoming-active";
              } else if (isBecomingInactive) {
                stateClass = "becoming-inactive";
              }

              return (
                <div
                  key={work.id}
                  className={`thumb ${isActive ? "active" : "inactive"} ${stateClass}`}
                  style={{
                    borderColor: isActive ? work.borderColor : "transparent",
                    transitionDelay: isBecomingActive || isBecomingInactive ? '0s' : '0.1s'
                  }}
                  onClick={() => handleChange(index)}
                >
                  <img src={work.logo} alt={work.title} />
                </div>
              );
            })}
          </div>
        </div>

        {/* Use the PageIndicators component */}
        <PageIndicators
          totalSlides={works.length}
          activeIndex={activeIndex}
          onChange={handleChange}
          color="#40BBD2" // Blue color from the image
          size="medium"
          mt={75}
        />
      </div>
    </section>
  );
};

export default WorksSlider;